/* eslint-disable no-unused-vars */
import * as axios from 'axios';
import StorageService from '@/services/common/storage.service';
import ErrorHandler from '@/helpers/errorHandler';
import NProgress from 'nprogress';
import store from '../../store/index';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import router from '../../router';

const refreshAuthLogic = failedRequest => loginByRefresh(failedRequest);

async function loginByRefresh (failedRequest) {
    // console.log('start loginByRefresh');
    let refreshToken = StorageService.getRefreshToken();
    StorageService.removeToken();
    // console.log(refreshToken);
    // axios.interceptors.response.eject(authInterceptor);
    if (!(refreshToken)) {
        // console.log('empty');
        let x = new Error('Can not refresh token');
        x.code = 401;
        return Promise.reject(x);
    }
    try {
        let requestData = {
            method: 'post',
            url: `${process.env.API_URL}/login`,
            data: {
                refresh_token: refreshToken,
                type: "refresh",
            },
        };
        // Do login
        let response = await ApiService.customRequest(requestData);
        if (response && response.status == 200) {
            // Save access token
            if (response.data.accessToken) {
                StorageService.saveToken(response.data.accessToken);
                StorageService.saveRefreshToken(response.data.refreshToken);
                // console.log("relogin done");

                // re-call the api
                failedRequest.response.config.headers['Authorization'] = 'Bearer ' + response.data.accessToken;
                console.log("recall pre api done");

                return Promise.resolve();
            }
        } else {
            let x = new Error('Can not refresh token');
            x.code = 401;

            // remove all tokens because it is not valid
            await StorageService.removeToken();
            await StorageService.removeRefreshToken();

            return Promise.reject(x);
        }
    } catch (error) {
        // console.log(" loginByRefresh error ===");
        // console.log(error);

        // make new specific Exception for Authorization case
        let x = new Error('Can not refresh token');
        x.code = 401;

        // remove all tokens because it is not valid
        StorageService.removeToken();
        StorageService.removeRefreshToken();

        return Promise.reject(x);
    }
    // console.log('end loginByRefresh');
}

// Instantiate the interceptor (you can chain it as it returns the axios instance)
const authInterceptor = createAuthRefreshInterceptor(axios, refreshAuthLogic);

axios.interceptors.request.use(
    config => {
    // BaseURL
    // config.baseURL = await process.env.API_URL;
        let url = process.env.API_URL;
        if (window.location.protocol === "https:") {
            url = url.replace("http", "https")
        }
        config.baseURL = url;
        config.timeout = process.env.TIMEOUT;

        // Authorization
        if (!config.headers.Authorization) {
            const token = StorageService.getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }

        // Content Type
        // config.headers.post['Content-Type'] = 'application/json';
        // config.headers.common = {'X-Requested-With': 'XMLHttpRequest'}

        // NProgress.start();
        store.commit('loading', true);

        return config;
    },
    error => {
        store.commit('loading', false);
        return Promise.reject(error);
    }
);

axios.interceptors.response.use((response) => {
    // console.log('response status' + response.status);
    // NProgress.done();
    store.commit('loading', false);
    return response;
}, function (error) {
    // NProgress.done();
    store.commit('loading', false);
    return ErrorHandler.errorResponseHandler(error);
});

const ApiService = {

    init (baseURL) {
        axios.defaults.baseURL = baseURL;
    },

    setHeader () {
        // console.log('set Header');
        axios.defaults.headers.common["Authorization"] = `Bearer ${StorageService.getToken()}`;
    },

    removeHeader () {
        axios.defaults.headers.common = {};
    },

    get (resource) {
        return axios.get(resource);
    },

    post (resource, data) {
        return axios.post(resource, data);
    },

    put (resource, data) {
        return axios.put(resource, data);
    },

    delete (resource) {
        return axios.delete(resource);
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest (data) {
        if (window.location.protocol === "https:") { // get,post,put,delete時は82行目で集約して対応
            data.url = data.url.replace("http", "https");
        };
        return axios(data);
    },
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/common/api.service.js